module.exports = __webpack_public_path__ + "static/img/组-566@2x.acb6d52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/组-566@2x.jpg
// module id = iZKS
// module chunks = 0